import { Box } from "@mui/material";
import SVG from "react-inlinesvg";
import { TAG_ICONS } from "src/config/store/services/tags-api/types";

type TagIconProps = {
  icon: TAG_ICONS;
  size?: number;
  color?: string;
};

export const TagIcon: React.FC<TagIconProps> = ({
  icon,
  size = 24,
  color = "white",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        ".no-stroke": {
          stroke: "none !important",
          fill: color,
        },
      }}
    >
      <SVG
        style={{
          stroke: color,
          width: `${size}px`,
          height: `${size}px`,
        }}
        src={`/images/tag-icons/${icon}.svg`}
      />
    </Box>
  );
};
